/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_PositionInputs */

const en_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption Position...`)
};

const fr_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position des sous-titres...`)
};

const de_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenposition...`)
};

const it_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione didascalia...`)
};

const ru_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция подписи...`)
};

const es_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición de subtítulo...`)
};

const zh_cn2_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题位置……`)
};

const ja_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション位置...`)
};

const hi_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन स्थिति...`)
};

const pt_pt2_caption_position = /** @type {(inputs: Caption_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição da legenda...`)
};

/**
* | output |
* | --- |
* | "Caption Position..." |
*
* @param {Caption_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position = /** @type {((inputs?: Caption_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_position(inputs)
	if (locale === "de") return de_caption_position(inputs)
	if (locale === "it") return it_caption_position(inputs)
	if (locale === "ru") return ru_caption_position(inputs)
	if (locale === "es") return es_caption_position(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_position(inputs)
	if (locale === "ja") return ja_caption_position(inputs)
	if (locale === "hi") return hi_caption_position(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_position(inputs)
	return en_caption_position(inputs)
});